{
  "name": "carussel-modularization",
  "version": "5.6.1",
  "description": "",
  "typeRoot": "",
  "targets": {
    "node": {
      "context": "node",
      "outputFormat": "commonjs",
      "distDir": "./dist/server"
    },
    "default": {
      "source": [
        "./src/dwt-app.ts",
        "./src/service-worker.ts",
        "./src/index.html"
      ],
      "distDir": "./dist",
      "publicUrl": "./"
    },
    "main": false
  },
  "alias": {
    "yamlparser": false,
    "punycode": false,
    "pseudomap": false
  },
  "scripts": {
    "clean:dist": "rimraf dist",
    "clean:tmp": "rimraf .tmp",
    "clean:cache": "rimraf .parcel-cache",
    "clean:serve": "rimraf serve",
    "clean": "run-p clean:*",
    "format": "prettier src/**/*.{ts,tsx} --write",
    "lint:prettier": "prettier src/**/*.{ts,tsx} --check",
    "lint:stylelint": "stylelint src/**/*.{ts,tsx} --custom-syntax postcss-styled-syntax",
    "lint:eslint": "eslint \"src/**/*.{ts,tsx}\" --cache --cache-location .tmp/.eslintcache --quiet",
    "lint": "run-p --aggregate-output lint:*",
    "build:app": "parcel build --no-scope-hoist",
    "build:server": "parcel build ./src/server/index.ts --target node --dist-dir ./dist/server",
    "build": "run-s clean lint build:*",
    "gcp-build": "",
    "serve:demo": "parcel ./src/index.html --dist-dir ./serve --port 3000 --no-cache",
    "serve": "run-s clean:serve clean:cache serve:*",
    "deploy:dev": "gcloud app deploy app.dev.yaml --project carussel-dwt --no-promote",
    "deploy:prod": "gcloud app deploy app.yaml --project carussel-dwt --no-promote",
    "deploy:staging": "gcloud app deploy app.staging.yaml --project carussel-dwt --no-promote",
    "ci:deploy:dev:master": "gcloud app deploy app.dev.yaml --project carussel-dwt --version master --no-promote --quiet",
    "ci:deploy:staging:master": "gcloud app deploy app.staging.yaml --project carussel-dwt --version master --no-promote --quiet",
    "ci:deploy:dev:beta": "gcloud app deploy app.dev.yaml --project carussel-dwt --version beta --no-promote --quiet",
    "ci:deploy:staging:beta": "gcloud app deploy app.staging.yaml --project carussel-dwt --version beta --no-promote --quiet",
    "ci:deploy:dev:stable": "gcloud app deploy app.dev.yaml --project carussel-dwt --version stable --no-promote --quiet",
    "ci:deploy:staging:stable": "gcloud app deploy app.staging.yaml --project carussel-dwt --version stable --no-promote --quiet",
    "postversion": "node ./script/setup-gae-version.js",
    "release:deploy": "npm run deploy:prod -- --version=%npm_config_gae_version%",
    "release": "npm ci && npm run clean && npm run build && npm run postversion && npm run release:deploy",
    "start": "node dist/server/index.js"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/CDM-eStrategiai/modularization.git"
  },
  "bugs": {
    "url": "https://github.com/CDM-eStrategiai/modularization/issues"
  },
  "homepage": "https://github.com/CDM-eStrategiai/modularization#readme",
  "devDependencies": {
    "@babel/core": "^7.20.12",
    "@parcel/bundler-experimental": "^2.7.0",
    "@parcel/reporter-dev-server": "^2.13.3",
    "@parcel/transformer-less": "^2.13.3",
    "@parcel/transformer-sass": "^2.13.3",
    "@parcel/transformer-typescript-tsc": "^2.13.3",
    "@types/body-parser": "^1.19.2",
    "@types/bunyan": "^1.8.8",
    "@types/dompurify": "2.4.0",
    "@types/express": "^4.17.15",
    "@types/glob": "^8.0.0",
    "@types/googlemaps": "^3.43.3",
    "@types/node-fetch": "2.6.3",
    "@types/object-hash": "^3.0.2",
    "@types/react": "^18.0.26",
    "@types/react-custom-scroll": "^5.0.1",
    "@types/react-dom": "^18.0.10",
    "@types/react-image-gallery": "^1.2.2",
    "@types/react-input-mask": "^3.0.2",
    "@types/react-router-dom": "^5.3.3",
    "@types/react-select": "^5.0.1",
    "@types/react-tabs": "^5.0.5",
    "@types/react-test-renderer": "^18.0.0",
    "@types/react-youtube-embed": "^1.0.4",
    "@types/styled-components": "^5.1.26",
    "@types/useragent": "^2.3.1",
    "@types/uuid": "^9.0.0",
    "@typescript-eslint/eslint-plugin": "^5.62.0",
    "@typescript-eslint/eslint-plugin-tslint": "^5.48.2",
    "@typescript-eslint/parser": "^5.62.0",
    "assert": "^2.1.0",
    "babel-plugin-styled-components": "^2.1.4",
    "browserify-zlib": "^0.2.0",
    "browserslist": "^4.21.4",
    "cross-env": "^7.0.3",
    "crypto-browserify": "^3.12.1",
    "cssnano": "^7.0.6",
    "eslint": "^8.57.1",
    "eslint-config-prettier": "^8.6.0",
    "eslint-formatter-summary": "^1.1.0",
    "eslint-plugin-import": "^2.32.0",
    "eslint-plugin-jsdoc": "^50.8.0",
    "eslint-plugin-prefer-arrow": "^1.2.3",
    "eslint-plugin-react": "^7.32.1",
    "eslint-plugin-unicorn": "^48.0.1",
    "glob": "^8.1.0",
    "https-browserify": "^1.0.0",
    "husky": "^8.0.3",
    "identity-obj-proxy": "^3.0.0",
    "less": "^4.1.3",
    "less-loader": "^11.1.0",
    "npm-run-all": "^4.1.5",
    "os-browserify": "^0.3.0",
    "parcel": "^2.13.3",
    "parcel-plugin-bundle-visualiser": "^1.2.0",
    "parcel-plugin-static-files-copy": "^2.6.0",
    "parcel-reporter-static-files-copy": "^1.5.3",
    "path-browserify": "^1.0.1",
    "postcss": "^8.5.1",
    "postcss-import": "^16.1.0",
    "postcss-styled-syntax": "^0.7.1",
    "prettier": "^2.8.3",
    "pretty-quick": "^3.1.3",
    "querystring-es3": "^0.2.1",
    "react-is": "^18.2.0",
    "react-test-renderer": "^18.2.0",
    "regenerator-runtime": "^0.13.11",
    "rimraf": "^4.1.0",
    "sass": "^1.57.1",
    "stream-browserify": "^3.0.0",
    "stream-http": "^3.2.0",
    "string_decoder": "^1.3.0",
    "style-loader": "^3.3.1",
    "stylelint": "^14.16.1",
    "stylelint-config-prettier": "^9.0.4",
    "stylelint-config-recommended": "^9.0.0",
    "stylelint-config-standard": "^29.0.0",
    "stylelint-config-styled-components": "^0.1.1",
    "stylelint-no-unsupported-browser-features": "^7.0.0",
    "stylelint-order": "^6.0.4",
    "stylelint-processor-styled-components": "^1.10.0",
    "ts-loader": "^9.4.2",
    "typescript": "^4.9.4",
    "url": "^0.11.4",
    "util": "^0.12.5",
    "vm-browserify": "^1.1.2"
  },
  "dependencies": {
    "@dnd-kit/core": "^6.1.0",
    "@dnd-kit/modifiers": "^7.0.0",
    "@dnd-kit/sortable": "^8.0.0",
    "@dnd-kit/utilities": "^3.2.2",
    "@fortawesome/fontawesome-svg-core": "latest",
    "@fortawesome/free-regular-svg-icons": "^6.2.1",
    "@fortawesome/free-solid-svg-icons": "^6.2.1",
    "@fortawesome/react-fontawesome": "^0.2.0",
    "@google-cloud/logging-bunyan": "^4.2.2",
    "@parcel/config-default": "^2.13.3",
    "@paypal/react-paypal-js": "^8.1.3",
    "@popperjs/core": "^2.11.8",
    "@stripe/react-stripe-js": "^2.7.1",
    "@stripe/stripe-js": "^3.4.1",
    "@swc/helpers": "^0.5.15",
    "@szhsin/react-accordion": "^1.4.1",
    "@tanstack/react-table": "^8.20.5",
    "@tinymce/tinymce-react": "^5.0.1",
    "@types/lodash": "^4.14.194",
    "@types/react-datepicker": "^6.2.0",
    "@types/react-slick": "^0.23.10",
    "body-parser": "^1.20.1",
    "buffer": "^6.0.3",
    "bunyan": "^1.8.15",
    "classnames": "^2.5.1",
    "core-js": "^3.27.1",
    "date-fns": "^2.29.3",
    "dompurify": "^2.4.3",
    "eventsource-parser": "^3.0.1",
    "express": "^4.18.2",
    "fs-extra": "^11.2.0",
    "gsap": "^3.13.0",
    "jest-environment-jsdom": "^29.3.1",
    "jest-extended": "^3.2.3",
    "jwt-decode": "^3.1.2",
    "ka-table": "^7.8.0",
    "lodash": "^4.17.21",
    "mobx": "^6.7.0",
    "mobx-react-lite": "^3.4.0",
    "node-fetch": "^2.6.9",
    "npm": "^11.1.0",
    "object-hash": "^3.0.0",
    "prop-types": "^15.8.1",
    "punycode": "^2.3.1",
    "rc-slider": "^11.1.8",
    "react": "^18.2.0",
    "react-360-view": "^0.1.3",
    "react-accessible-accordion": "^5.0.0",
    "react-accessible-treeview": "^2.8.3",
    "react-animate-height": "3.2.0",
    "react-currency-input-field": "^3.6.12",
    "react-custom-scroll": "^5.0.0",
    "react-custom-scrollbars-2": "^4.5.0",
    "react-datepicker": "^6.6.0",
    "react-device-detect": "^2.2.3",
    "react-dom": "^18.2.0",
    "react-draggable": "^4.4.5",
    "react-google-recaptcha-v3": "^1.10.1",
    "react-hook-form": "^7.55.0",
    "react-image-crop": "^11.0.7",
    "react-image-gallery": "^1.3.0",
    "react-image-zooom": "^1.3.5",
    "react-input-mask": "^3.0.0-alpha.2",
    "react-lite-yt-embed": "^1.2.7",
    "react-number-format": "^5.3.4",
    "react-router": "^7.1.5",
    "react-router-dom": "^6.11.2",
    "react-scrollbars-custom": "^4.1.1",
    "react-select": "^5.7.0",
    "react-slick": "^0.29.0",
    "react-slideshow-image": "^4.3.0",
    "react-stripe-checkout": "^2.6.3",
    "react-switch": "^7.0.0",
    "react-tabs": "^6.0.0",
    "react-toastify": "^9.1.3",
    "react-tooltip": "^5.28.0",
    "react-use-file-upload": "^0.9.5",
    "reactjs-popup": "^2.0.5",
    "regenerator-runtime": "^0.13.11",
    "request": "^2.88.2",
    "resize-observer-polyfill": "^1.5.1",
    "simplebar": "^6.2.5",
    "simplebar-react": "^3.1.0",
    "slick-carousel": "^1.8.1",
    "styled-components": "^5.3.6",
    "tinymce": "^7.1.0",
    "tslib": "^2.4.1",
    "useragent": "^2.3.0",
    "uuid": "^9.0.0",
    "workbox-cacheable-response": "^6.5.4",
    "workbox-expiration": "^6.5.4",
    "workbox-routing": "^6.5.4",
    "workbox-strategies": "^6.5.4",
    "yamlparser": "^0.0.2"
  },
  "husky": {
    "hooks": {
      "pre-commit": "pretty-quick --staged"
    }
  },
  "browserslist": [
    "> 1%",
    "last 1.5 years",
    "not dead",
    "ie >= 11",
    "not op_mini all"
  ],
  "staticFiles": {
    "staticPath": "src/assets/common",
    "watcherGlob": "emission/**/*",
    "staticOutDir": "emission",
    "outDirPattern": "**/{dist,serve}"
  }
}
